// extracted by mini-css-extract-plugin
export var contentContainer = "index-module--contentContainer--944c1 px-40";
export var root = "index-module--root--b02bb bg-black text-white lg_py-24 relative lg_aspect-[16/5] mb-8 flex items-center";
export var startQuote = "index-module--startQuote--9de73 text-[180px] font-bold h-[120px] -mt-[60px] block text-orange opacity-70";
export var titleContainer = "index-module--titleContainer--613b6 font-serif italic text-2xl";